<template lang="pug">
    list-box
        div(slot="header" )
            | {{ $i18n.t('support.support_conversations_header') }}
        .messages-box(slot="preview")
            .messages__menu
                cs-loader(v-if='isAmountsLoading')
                template(v-else)
                    router-link.menu__item(
                        :to="{name: 'support', params: { status: 1 }}"
                        :class="{'menu__item--current': current === 'active'}"
                    )
                        | {{ $i18n.t('support.support_conversations_active') }}
                        | ({{ amountOfActive }})
                    router-link.menu__item(
                        :to="{name: 'support', params: { status: 0 }}"
                    )
                        | {{ $i18n.t('support.support_conversations_resolved') }}
                        | ({{ amountOfResolved }})
                    router-link.menu__item(
                        :to="{name: 'support', params: { all: true }}"
                    )
                        | {{ $i18n.t('support.support_conversations_all') }}
            .messages__body
                .messages-box__conversation-info
                    router-link.messages-box__receiver(
                        v-if='receiver && receiver.isUser',
                        :to="{\
                            name: 'user:profile',\
                            params: {id: receiver.id, type: receiver.type}\
                        }"
                    )
                        img.avatar(:src='receiver.avatar')
                        | {{ receiver.firstName }} {{ receiver.lastName }}
                    a.messages-box__change-status(href='javascript://', @click='updateStatus')
                        svg-icon.messages-box__change-status-icon(name="folder", size="large" )
                        span {{ statusState }}
                divider(:margin="'0 auto'" not-show-last-child)
                template(v-if="!isLoading" )
                    .messages
                        div(ref='messages')
                            v-infinite-scroll.messages__container(
                                @top="loadMessages('top')",
                                @bottom="loadMessages('bottom')"
                            )
                                .has-text-centered(v-if='messages.length === 0')
                                    | {{ $i18n.t('conversations.conversations_conversation_noMessages') }}
                                .messages-loader(v-if='currentTopPage !== lastPage')
                                    cs-loader
                                template(v-for='(messages, date) in groupMessagesByDate')
                                    .messages__date {{ getDay(date) }}
                                    .letter(
                                        v-for='message in messages',
                                        :key='message.id', :ref='message.id',
                                        @scroll='loadMessages(message.id)'
                                    )
                                        .letter__header--small
                                            router-link(
                                                :to="{\
                                                    name: 'user:profile',\
                                                    params: {id: message.sender.id, type: message.sender.type}\
                                                }"
                                            )
                                                img.avatar(:src='message.sender.avatar')
                                            div
                                                .letter__name {{ senderName(message) }}
                                                .letter__time {{ getTime(message.createdAt) }}
                                        router-link.letter__img(
                                            :to="{\
                                                    name: 'user:profile',\
                                                    params: {id: message.sender.id, type: message.sender.type}\
                                                }"
                                        )
                                            img.avatar(:src='message.sender.avatar')
                                        .letter__content
                                            .letter__header
                                                .letter__name {{ senderName(message) }}
                                                .letter__time {{ getTime(message.createdAt) }}
                                            .letter__body
                                                .letter__text
                                                    span(v-html='filteredMessage(message.body)', v-if='message.body')
                                                .letter__attachments(v-if='message.ticketAttachments.length > 0')
                                                    a.message__attachment(
                                                        v-for='attachment in message.ticketAttachments'
                                                        :href='attachment.url',
                                                        target='_blank'
                                                    )
                                                        svg-icon.letter__file-icon(name="paper", width="22px", height="22px")
                                                        | {{ attachment.originalName }}
                                    divider(:margin="'0 auto'" not-show-last-child)
                                .messages-loader(v-if='currentBottomPage !== 1')
                                    cs-loader
                        .message__form
                            textarea.textarea(
                                :placeholder="$i18n.t('conversations.conversations_conversation_messagePlaceholder')",
                                @keydown.enter='keyDownHandler',
                                v-model='message',
                                v-autosize='message',
                                :class="{'textarea--disabled': (isMessageLoading || ticket && !ticket.status)}",
                                ref='textarea',
                                v-focus=''
                            )
                            .message__buttons
                                label.label-button(
                                    for='file-select',
                                    :class="ticket && !ticket.status && 'label-button--disabled'"
                                )
                                    svg-icon.label-button__icon(name="paperclip", height="19px", width="19px")
                                    span
                                        | {{ $i18n.t('conversations.conversations_conversation_attachFiles') }}
                                    input#file-select(type='file', ref='fileSelect', @change='setFiles', multiple)
                                cs-button(
                                    color="blue"
                                    @click="sendMessageHandler"
                                    :disabled="cantSendMessage"
                                )
                                    | {{ $i18n.t('conversations.conversations_conversation_sendMessage') }}
                            .message__attachment-files(v-if='files.length')
                                .message__attachment(v-for='(file, index) in files')
                                    | {{ file.name }}
                                    a.message__delete-file(href='javascript://', @click='deleteFile(index)')
                                        svg-icon(name="cancel", size="x-large")
                                    progress(
                                        v-if="isFileProgressShouldDisplay(index)",
                                        max='100',
                                        :value="fileProgressValue(index)"
                                    )
                cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import TicketApi from '../../../api/communication/ticket';
    import TicketMessageApi from '../../../api/communication/ticket-messages';

    import amountsOfTickets from '../../../utils/communication/amountsOfTickets';
    import handleTicketEvents from '../../../utils/communication/handleTicketEvents';

    import ListBox from '../../lists/ListBox.vue';

    import _ from 'lodash';
    import { mapState } from 'vuex';
    import moment from 'moment';
    import linkifyStr from 'linkifyjs/string';

    export default {
        props: ['id'],
        mixins: [amountsOfTickets, handleTicketEvents],
        mounted() {
            this.fetchData();
            window.addEventListener('beforeunload', this.setDataToSessionStorage, { once: true });
            this.message = window.sessionStorage.getItem(`messageToTicket${this.id}`) || '';
        },
        beforeDestroy() {
            this.setDataToSessionStorage();
            window.removeEventListener('beforeunload', this.setDataToSessionStorage);
        },
        components: { ListBox },
        data() {
            return {
                messages: [],
                ticket: null,
                isLoading: false,
                receiver: null,
                form: {
                    body: '',
                    ticketId: null,
                    amountOfElements: 30,
                },
                message: '',
                files: [],
                isMessageLoading: false,
                isActive: false,
                current: '',
                isAmountsLoading: false,
                currentTopPage: null,
                currentBottomPage: null,
                lastPage: null,
                filesProgressLoaders: [],
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            groupMessagesByDate() {
                this.messages = _.orderBy(this.messages, ['createdAt']).filter(message => message);
                return _.groupBy(this.messages, message => moment(message.createdAt).format('YYYY-MM-DD'));
            },
            placeholder() {
                if (this.ticket) {
                    return this.ticket.status
                        ? this.$i18n.t('conversations.conversations_conversation_messagePlaceholder')
                        : this.$i18n.t('support.support_message_info');
                }
            },
            statusState() {
                return this.ticket && this.ticket.status
                    ? this.$i18n.t('support.support_status_resolveTicket')
                    : this.$i18n.t('support.support_status_resumeTicket');
            },
            cantSendMessage() {
                return (this.ticket && !this.ticket.status) || !this.message.length;
            },
        },
        methods: {
            filteredMessage (message) {
                message = linkifyStr(message, {});
                return message
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>');
            },
            senderName(message) {
                if (
                    message.sender.id !== this.user.id &&
                    message.sender.departments &&
                    message.sender.departments.length
                ) {
                    if (message.sender.type === 'support') {
                        return this.$i18n.t('support.support_agent');
                    }
                    if (message.sender.type === 'manager') {
                        return this.$i18n.t('support.manager_agent');
                    }
                    return this.$i18n.t('support.support_agent') + ' ' + message.sender.fullName;
                }
                return message.sender.fullName;
            },
            fetchData() {
                this.isLoading = true;
                TicketApi.show(this.id)
                    .then(ticket => {
                        this.ticket = ticket;
                        this.form.ticketId = this.ticket.id;
                        if (this.user.id !== this.ticket.userId) {
                            this.receiver = this.ticket.user;
                            this.receiver.isUser = true;
                        } else {
                            this.receiver = this.ticket.department;
                            this.receiver.status = 'active';
                        }
                        if (this.ticket.lastMessage && this.ticket.lastMessage.unread) {
                            TicketApi.update(this.ticket.id, {isRead: true});
                        }
                        this.sendForm();
                    })
                    .catch(err => {
                        if (err && err.response && err.response.data.status_code === 403) {
                            this.$toasted.error(err.response.data.message);
                            this.$router.push({ name: 'support' });
                        }
                        this.isLoading = false;
                    });
            },
            sendForm() {
                this.isLoading = true;
                this.form.ticketId = this.ticket.id;
                if (this.messageId) {
                    this.form.messageId = this.messageId;
                } else {
                    this.form.messageId = this.ticket.lastMessage.id;
                }
                TicketMessageApi.list(this.form)
                    .then(data => {
                        this.messages = data.data.reverse();
                        this.currentTopPage = data.currentPage;
                        this.currentBottomPage = data.currentPage;
                        if (!data.data.length) {
                            this.lastPage = 1;
                        } else {
                            this.lastPage = data.lastPage;
                        }
                        delete this.form.messageId;
                        this.isLoading = false;
                    })
                    .then(() => {
                        this.scrollToMessage();
                    });
            },
            scrollToMessage() {
                if (this.messageId) {
                    if (this.$refs[this.messageId]) {
                        this.$refs[this.messageId][0].scrollIntoView();
                    }
                } else if (this.form.body === '') {
                    if (this.$refs[this.ticket.lastMessage.id]) {
                        this.$refs[this.ticket.lastMessage.id][0].scrollIntoView();
                    }
                }
            },
            setDataToSessionStorage() {
                window.sessionStorage.setItem(`messageToTicket${this.id}`, this.message);
            },
            getTime(date) {
                return moment(date).format('LT');
            },
            getDay(date) {
                date = moment(date);
                if (date.year() !== moment().year()) {
                    return date.format('LL');
                } else if (date.diff(moment(new Date()), 'days') >= -1) {
                    return date.calendar() + ', ' + date.format('D MMMM');
                }
                return date.format('D MMMM');
            },
            loadMessages(direction) {
                let form = this.form;
                if (direction === 'top') {
                    if (this.currentTopPage < this.lastPage) {
                        this.currentTopPage++;
                        form.page = this.currentTopPage;
                    } else {
                        return;
                    }
                } else {
                    if (this.currentBottomPage > 1) {
                        this.currentBottomPage--;
                        form.page = this.currentBottomPage;
                    } else {
                        return;
                    }
                }
                TicketMessageApi.list(form)
                    .then(data => {
                        this.messages = _.uniqBy(this.messages.concat(data.data), 'id');
                        return data.data[0].id;
                    })
                    .then(id => {
                        if (direction === 'top') {
                            this.$refs[id][0].scrollIntoView();
                        }
                    });
            },
            keyDownHandler(event) {
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.sendMessageHandler();
                }
            },
            deleteFile(index) {
                this.files.splice(index, 1);
                this.filesProgressLoaders.splice(index, 1);
            },
            setFiles(e) {
                Array.from(e.target.files).forEach((file, index) =>
                    this.setFile(file, index + this.filesProgressLoaders.length)
                );
            },
            setFile(file, index) {
                if (this.isInFiles(file)) {
                    return;
                }
                let reader = new FileReader();
                reader.addEventListener('loadstart', this.handleFileLoadStart);
                reader.addEventListener('loadend', event => this.handleFileLoadEnd(event, index));
                reader.addEventListener('progress', event => this.handleFileLoadProgress(event, index));
                reader.readAsDataURL(file);
                this.files.push(file);
            },
            handleFileLoadStart(event) {
                this.filesProgressLoaders.push({ loaded: event.loaded, total: event.total });
            },
            handleFileLoadEnd(event, index) {
                this.filesProgressLoaders[index].loaded = this.filesProgressLoaders[index].total;
            },
            handleFileLoadProgress(progress, index) {
                this.filesProgressLoaders[index].loaded = progress.loaded;
                this.filesProgressLoaders[index].total = progress.total;
            },
            isInFiles(file) {
                for (let localFile of this.files) {
                    if (localFile.name === file.name && file.size === localFile.size) {
                        return true;
                    }
                }
                return false;
            },
            sendMessageHandler() {
                if (this.receiver && this.receiver.status !== 'archived') {
                    this.sendMessage();
                    return;
                } else if (this.receiver) {
                    this.$toasted.error(this.$i18n.t('conversations.conversations_createMessage_receiverIsInArchive'));
                    return;
                }
                this.$toasted.error(this.$i18n.t('conversations.conversations_createMessage_receiverIsDeleted'));
            },
            sendMessage() {
                if ((this.message.trim().length > 0 || this.files.length > 0) && !this.isMessageLoading) {
                    this.isMessageLoading = true;
                    this.$refs['textarea'].blur();
                    let message = this.message
                        .split('\n')
                        .filter(string => string)
                        .join('\n');
                    let formData = new FormData();
                    formData.append('body', message);
                    formData.append('ticket_id', this.form.ticketId);
                    this.files.forEach((element, index) => {
                        formData.append(`files[${index}]`, element);
                    });
                    TicketMessageApi.create(formData)
                        .then(data => {
                            this.message = '';
                            window.sessionStorage.removeItem(`messageToTicket${this.id}`);
                            this.ticket.lastMessage = data;
                            this.files = [];
                            this.$refs['textarea'].focus();
                            this.isMessageLoading = false;
                            return data;
                        })
                        .then(message => {
                            this.$refs[message.id] && this.$refs[message.id][0].scrollIntoView();
                        })
                        .catch(error => {
                            this.isMessageLoading = false;
                            if (error.status || error.response.status === 403) {
                                this.$toasted.error(error.response.data.message);
                            }
                        });
                }
            },
            updateStatus() {
                this.isLoading = true;
                let status = this.statusState === this.$i18n.t('support.support_status_resolveTicket') ? 0 : 1;
                let form = {
                    ticketsIds: [this.ticket.id],
                    status: status,
                };
                TicketApi.updateSome(form)
                    .then(() => {
                        this.fetchData();
                    })
                    .catch(error => {
                        this.$toasted.error(this.$root.$t('errors.message_handling'));
                        this.isLoading = false;
                    });
            },
            handleStatusSelect(selector) {
                switch (selector) {
                    case 'active':
                        this.$router.push({ name: 'support', params: { status: 1 } });
                        break;
                    case 'resolved':
                        this.$router.push({ name: 'support', params: { status: 0 } });
                        break;
                    case 'all':
                        this.$router.push({ name: 'support', params: { all: true } });
                        break;
                }
            },
            statusName(status) {
                return status ? this.$i18n.t('support.support_conversations_' + status) : '';
            },
            isFileProgressShouldDisplay(index) {
                const fileLoadProgress = this.filesProgressLoaders[index];
                return fileLoadProgress && fileLoadProgress['loaded'] < fileLoadProgress['total'];
            },
            fileProgressValue(index) {
                const fileLoadProgress = this.filesProgressLoaders[index];
                return fileLoadProgress && (fileLoadProgress['loaded'] / fileLoadProgress['total']) * 100;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .messages-box {
        display: flex;
    }

    .messages__menu {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: column;

            font-size: 18px;
            line-height: 42px;

            min-width: 140px;
            margin-right: 30px;
        }
    }

    .menu__item,
    .messages-box__receiver,
    .conversation__button {
        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .menu__item--current {
        color: $x-color-black;
        text-decoration: none;

        &:hover {
            color: $x-color-black;
            text-decoration: none;
        }
    }

    .messages__body {
        padding: 0;
        width: 100%;
    }

    .messages-box__status-selector {
        margin: 30px 0;
        display: flex;
        @include media($xlg) {
            display: none;
        }
    }

    .messages-box__conversation-info {
        display: flex;
        flex-direction: column;
        margin: 30px 0;
        align-items: flex-start;
        @include media($md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        @include media($xlg) {
            margin: 15px 0 30px 0;
        }
    }

    .messages-box__receiver {
        display: flex;
        align-items: center;
        margin: 0 20px 30px 0;
        @include media($md) {
            margin: 0;
        }
        @include media($xlg) {
            white-space: nowrap;
        }
    }

    .messages-box__change-status {
        display: flex;
        text-align: left;

        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .messages-box__change-status-icon {
        margin-right: 10px;
    }

    .messages-box__conversation {
        display: flex;
        align-items: center;
        margin-right: 20px;
        @include media($xlg) {
            white-space: nowrap;
        }
    }

    .conversation__info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 80px;
    }

    .conversation__button {
        margin-top: 10px;
    }

    .messages-box__search-box {
        margin: 15px 0;
        display: flex;
        align-items: center;
        @include media($xl) {
            min-width: 330px;
        }
    }

    .messages-box__search-box .cs-input {
        margin: 0;
    }

    .messages-box__search-icon {
        color: $hsl-color-blue-56;
        margin-left: 10px;
    }

    .messages-box__fields {
        display: flex;
        padding: 0;
        margin: 30px 0;
    }

    .messages-box__message-statuses {
        display: flex;
        flex-direction: column;
        @include media($xlg) {
            flex-direction: row;
        }
    }

    .messages-box__message-status-checkbox {
        margin: 0 20px 0 0;
    }

    .messages-box__message-status {
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }

        &:last-child {
            margin: 0;
        }

        @include media($xlg) {
            margin: 0 60px 0 0;
        }
    }

    .messages-box__status-icon {
        margin-right: 10px;
    }

    .message {
        display: flex;
        align-items: center;
    }

    .messages__info {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
    }

    .avatar {
        border-radius: 50%;
        margin-right: 30px;
        max-height: none;
        height: 80px;
        width: 80px;
        border: none;
    }

    .messages__container {
        max-height: 400px;
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 1rem;
        margin-bottom: 10px;
        @include media($md) {
            padding-right: 1.5rem;
        }
    }

    .messages__date {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: $x-color-black;
        text-align: center;
    }

    .letter {
        padding: 26px 0;
        min-height: 4.5rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .letter__header--small {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        @include media($md) {
            display: none;
        }
    }

    .letter__content {
        width: 100%;
    }

    .letter__header,
    .letter__img {
        display: none;
        margin-bottom: 10px;
        @include media($md) {
            display: block;
        }
    }

    .letter__name {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
    }

    .letter__time {
        font-size: 14px;
        line-height: 17px;
        color: rgba($hsl-color-gray-20, 0.6);
        margin: 10px 0;
    }

    .letter__body {
        margin-bottom: 30px;
    }

    .letter__text {
        line-height: 24px;
        white-space: pre-line;
        word-break: break-word;
    }

    .textarea {
        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: $x-color-white;
        box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 100px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .textarea--disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color: $x-color-white;
        color: $hsl-color-gray-74;
    }

    .message__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 30px;
        @include media($md) {
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .message__attachment-files {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-top: 20px;
    }

    .letter__attachments {
        padding-top: 5px;
        white-space: pre-line;
        word-break: break-word;
    }

    .message__attachment {
        display: flex;
        align-items: center;
        margin-right: 20px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        font-size: 16px;
        line-height: 24px;
        margin-top: 10px;
    }

    .message__delete-file {
        color: $hsl-color-gray-74;

        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .label-button {
        box-sizing: border-box;

        padding: 15px 30px;

        transition: 0.3s;

        font-weight: normal;
        font-size: 16px;
        line-height: 19px;

        border-radius: $border-radius-40;

        cursor: pointer;
        outline: none;

        display: flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;

        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;

        margin-bottom: 10px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .label-button:hover {
        color: $x-color-white;
        background-color: $hsl-color-blue-48;
    }

    .label-button--disabled {
        cursor: default;
        color: $hsl-color-gray-52;
        background: $hsl-color-gray-92;
        border-color: transparent;

        opacity: $opacity-disabled;
        pointer-events: none;
    }

    .label-button__icon {
        margin-right: 14px;
    }

    #file-select {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
    }

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar {
        background-color: #f5f5f5;
        height: 2px;
    }

    ::-webkit-scrollbar-thumb {
        height: 2px;
        background: $color-grey-600;
    }
</style>
